import { Spaces } from '@trii/types';

const formatContactName = (
  firstName: string = '',
  lastName: string = '',
  nameFormat: Spaces.nameFormat = Spaces.nameFormat.FIRST_LAST,
): string => {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';

  switch (nameFormat) {
    case Spaces.nameFormat.FIRST_LAST:
      return `${first} ${last}`.trim();
    case Spaces.nameFormat.LAST_FIRST:
      return `${last} ${first}`.trim();
    case Spaces.nameFormat.FIRST_COMMA_LAST:
      return first && last ? `${first}, ${last}` : first || last;
    case Spaces.nameFormat.LAST_COMMA_FIRST:
      return first && last ? `${last}, ${first}` : last || first;
    default:
      return `${first} ${last}`.trim();
  }
};

export default formatContactName;
